/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import PartnerKycSuccess from "./PartnerSuccessScreen.container";

export default PartnerKycSuccess;
